const readStoredJson = (key) => {
    try {
        const value = localStorage.getItem(key)
        return value ? JSON.parse(value) : null
    } catch (error) {
        return null
    }
}

const getArray = (...values) =>
    values.find((value) => Array.isArray(value)) || []

const permissionActions = [
    'read',
    'edit',
    'create',
    'delete',
    'aprobacion',
    'rechazo',
    'estatus',
    'exportacion',
    'autorizacion',
    'acceso',
]

const hasPermissionAction = (permission = {}) =>
    permissionActions.some((action) => Number(permission[action]) === 1)

const buildPermission = (modulo) => {
    const permission = modulo.permisos?.[0] || {}
    const permisos = permissionActions.filter((action) => Number(permission[action]) === 1)

    return {
        ...permission,
        permisos,
        modulo,
    }
}

export const mergeAuthSession = (currentAuth = {}, nextAuth = {}) => {
    const accessToken = nextAuth.access_token || currentAuth.access_token || ''
    const storedUser = accessToken ? readStoredJson('user') || {} : {}
    const storedModulos = accessToken ? readStoredJson('modulos') : []
    const currentUser = currentAuth.user || {}
    const nextUser = nextAuth.user || {}

    const user = {
        ...storedUser,
        ...currentUser,
        ...nextUser,
        permisos: getArray(nextUser.permisos, currentUser.permisos, storedUser.permisos),
    }

    const auth = {
        ...currentAuth,
        ...nextAuth,
        access_token: accessToken,
        user,
        modulos: getArray(nextAuth.modulos, currentAuth.modulos, storedModulos),
    }

    if (Array.isArray(nextUser.permisos)) {
        localStorage.setItem('user', JSON.stringify(user))
    }
    if (Array.isArray(nextAuth.modulos)) {
        localStorage.setItem('modulos', JSON.stringify(auth.modulos))
    }

    return auth
}

export const buildAuthAccessFromModules = (auth = {}, apiModulos = []) => {
    const permisos = []
    const modulos = apiModulos.reduce((groups, group) => {
        const activeModulos = (group.modulos || []).filter((modulo) => {
            const permission = modulo.permisos?.[0]
            if (!hasPermissionAction(permission)) return false

            permisos.push(buildPermission(modulo))
            return true
        })

        if (activeModulos.length) {
            groups.push({
                ...group,
                modulos: activeModulos,
            })
        }

        return groups
    }, [])

    return mergeAuthSession(auth, {
        user: {
            ...auth.user,
            permisos,
        },
        modulos,
    })
}

/**
 * Sesión al iniciar: la respuesta de user/login trae los módulos con la estructura vieja (sin secciones
 * ni los grupos nuevos), y el menú solo se acomodaba al recargar, cuando App pide modulos/user/{id}.
 * Aquí se hace esa misma consulta antes de entrar, para que el menú salga bien desde el primer momento.
 * Si la consulta falla, se entra con lo que trajo el login y el refresco de App lo corrige después.
 */
export const sesionDesdeLogin = async (data = {}, axiosInstance, urlBase) => {
    const { access_token, user, modulos, departamento } = data
    localStorage.setItem('access_token', access_token)
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('modulos', JSON.stringify(modulos || []))
    localStorage.setItem('departamento', JSON.stringify(departamento))
    let auth = { access_token, user, modulos: modulos || [], departamento }
    try {
        if (user && user.id) {
            const r = await axiosInstance.get(`${urlBase}modulos/user/${user.id}`, { headers: { Authorization: `Bearer ${access_token}` } })
            if (Array.isArray(r.data && r.data.modulos)) auth = buildAuthAccessFromModules(auth, r.data.modulos)
        }
    } catch (e) { /* se queda con los módulos del login */ }
    return auth
}
